// // Code review - In Progress
// // Documentation - In Progress
// import React, { useEffect, useState } from "react";
// import { NavLink, useLocation, useNavigate } from "react-router-dom";
// import fpaiLogo from "../image/FPAILogo.jpg";
// import MainPopup from "../popup-containers/MainPopup";
// import UserProfile from "../popup-containers/UserProfile";
// import { useUserCapability } from "./ConstantReducerProvider";
// import PasswordPopup from "../popup-containers/PasswordPopup";
// import SystemSettingsPopup from "../popup-containers/SystemSettingsPopup";
// import Notifications from "../popup-containers/Notifications";
// import { BindPostAPI } from "../services/APIConnection";

// function TopMenu() {
//   const loction = useLocation();
//   const [currentMenuId, setCurrentMenuId] = useState(null);
//   const { userProfileState, dispatch } = useUserCapability();

//   const userProfileDatas = userProfileState.userProfile;
//   const userCapabilityTopMenu = userProfileState.userVsCapability;
//   const userProfileImg =
//     userProfileDatas && userProfileDatas.length > 0
//       ? userProfileDatas[0].UserProfileImg
//       : null;

//   const userName =
//     userProfileDatas && userProfileDatas.length > 0
//       ? userProfileDatas[0].UserName
//       : null;
//   const desigantion =
//     userProfileDatas && userProfileDatas.length > 0
//       ? userProfileDatas[0].Designation
//       : null;

//   useEffect(() => {
//     var createdBy = sessionStorage.getItem("createdBy");
//     if (createdBy == null || createdBy == "") {
//       navigate("/");
//     }
//   }, []);
//   useEffect(() => {
//     if (loction) {
//       const menuId1 = loction.state?.menuId;
//       const MenuId = userCapabilityTopMenu
//         .filter((x) => x.MenuPath == loction.pathname)
//         .map((item) => item.MstMenuId)
//         .toString();
//       const getMstMainMenuHeadingId = userCapabilityTopMenu
//         .filter((x) => x.MenuPath == loction.pathname)
//         .map((item) => item.MstMenuHeadingId)
//         .toString();

//       if (
//         getMstMainMenuHeadingId == 1 ||
//         getMstMainMenuHeadingId == 2 ||
//         getMstMainMenuHeadingId == 3 ||
//         getMstMainMenuHeadingId == 4
//       ) {
//         setCurrentMenuId(getMstMainMenuHeadingId); // Set current menu ID based on the retrieved ID
//       }
//       if (menuId1 == "3") {
//         setCurrentMenuId(2);
//       } else if (MenuId == "3,27") {
//         setCurrentMenuId(3);
//       }
//     }
//   }, [loction, userProfileState]);
//   if (userCapabilityTopMenu.filter((item) => item.MstMenuHeadingId === 1)) {
//     var dynamnicTopMenu = userCapabilityTopMenu
//       .filter((item) => item.MstMenuHeadingId === 1)
//       .map((item) => ({
//         title: item.MenuHeading,
//         menuHeadingId: item.MstMenuHeadingId,
//         menuPath: item.MenuPath,
//       }));

//     var dynamnicTopMenuMobile = userCapabilityTopMenu
//       .filter((item) => item.MstMenuHeadingId === 1)
//       .map((item) => ({
//         title: item.MenuHeading,
//         menuHeadingId: item.MstMenuHeadingId,
//         menuPath: item.MenuPath,
//         icon: (
//           <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
//             <path d="M21 16V4H3v12h18m0-14a2 2 0 012 2v12a2 2 0 01-2 2h-7v2h2v2H8v-2h2v-2H3a2 2 0 01-2-2V4c0-1.11.89-2 2-2h18M5 6h9v5H5V6m10 0h4v2h-4V6m4 3v5h-4V9h4M5 12h4v2H5v-2m5 0h4v2h-4v-2z" />
//           </svg>
//         ),
//       }));
//   } else {
//     console.log("LandingPage permission denied");
//   }

//   if (userCapabilityTopMenu.filter((item) => item.MstMenuHeadingId === 2)) {
//     var dynamnicTopMenu2 = userCapabilityTopMenu
//       .filter((item) => item.MstMenuHeadingId === 2)
//       .map((item) => ({
//         title: item.MenuHeading,
//         menuHeadingId: item.MstMenuHeadingId,
//         menuPath: item.MenuPath,
//         mstMenuId: item.MstMenuId,
//       }));
//   } else {
//     console.log("Administrator permission denied");
//   }

//   if (dynamnicTopMenu2.length > 0) {
//     var TopMenuAdmin = {
//       title: dynamnicTopMenu2[0].title,
//       menuHeadingId: dynamnicTopMenu2[0].menuHeadingId,
//       menuPath: dynamnicTopMenu2[0].menuPath,
//       menuId: dynamnicTopMenu2[0].mstMenuId,
//     };

//     var TopMenuAdminMobile = {
//       title: dynamnicTopMenu2[0].title,
//       menuHeadingId: dynamnicTopMenu2[0].menuHeadingId,
//       menuPath: dynamnicTopMenu2[0].menuPath,
//       menuId: dynamnicTopMenu2[0].mstMenuId,
//       icon: (
//         <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
//           <path fill="none" d="M0 0h24v24H0z" />
//           <path d="M12 14v8H4a8 8 0 018-8zm0-1c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6zm2.595 5.812a3.51 3.51 0 010-1.623l-.992-.573 1-1.732.992.573A3.496 3.496 0 0117 14.645V13.5h2v1.145c.532.158 1.012.44 1.405.812l.992-.573 1 1.732-.992.573a3.51 3.51 0 010 1.622l.992.573-1 1.732-.992-.573a3.496 3.496 0 01-1.405.812V22.5h-2v-1.145a3.496 3.496 0 01-1.405-.812l-.992.573-1-1.732.992-.572zM18 17a1 1 0 100 2 1 1 0 000-2z" />
//         </svg>
//       ),
//     };
//   }

//   if (userCapabilityTopMenu.filter((item) => item.MstMenuHeadingId === 3)) {
//     var dynamnicTopMenu3 = userCapabilityTopMenu
//       .filter((item) => item.MstMenuHeadingId === 3)
//       .map((item) => ({
//         title: item.MenuHeading,
//         menuHeadingId: item.MstMenuHeadingId,
//         menuPath: item.MenuPath,
//         mstMenuId: item.MstMenuId,
//         relatedMenu: item.RelatedMenu ? item.RelatedMenu : null,
//       }));
//   } else {
//     console.log("Transaction permission denied");
//   }

//   if (dynamnicTopMenu3.length > 0) {
//     var TopMenuTransaction = {
//       title: dynamnicTopMenu3[0].title,
//       menuHeadingId: dynamnicTopMenu3[0].menuHeadingId,
//       menuPath: dynamnicTopMenu3[0].menuPath,
//       menuId: dynamnicTopMenu3[0].mstMenuId,
//       relatedMenu: dynamnicTopMenu3[0].relatedMenu
//         ? dynamnicTopMenu3[0].relatedMenu
//         : null,
//     };
//     var TopMenuTransactionMobile = {
//       title: dynamnicTopMenu3[0].title,
//       menuHeadingId: dynamnicTopMenu3[0].menuHeadingId,
//       menuPath: dynamnicTopMenu3[0].menuPath,
//       menuId: dynamnicTopMenu3[0].mstMenuId,
//       relatedMenu: dynamnicTopMenu3[0].relatedMenu
//         ? dynamnicTopMenu3[0].relatedMenu
//         : null,
//       icon: (
//         <svg viewBox="0 0 640 512" fill="currentColor" className="w-6 h-6">
//           <path d="M535 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l64 64c4.5 4.5 7 10.6 7 17s-2.5 12.5-7 17l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-174-.2c-13.3 0-24-10.7-24-24s10.7-24 24-24h174.1L535 41zM105 377l-23 23h174c13.3 0 24 10.7 24 24s-10.7 24-24 24H81.9l23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 441c-4.5-4.5-7-10.6-7-17s2.5-12.5 7-17l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM96 64h241.9c-3.7 7.2-5.9 15.3-5.9 24 0 28.7 23.3 52 52 52h117.4c-4 17 .6 35.5 13.8 48.8 20.3 20.3 53.2 20.3 73.5 0l19.3-19.3V384c0 35.3-28.7 64-64 64H302.1c3.7-7.2 5.9-15.3 5.9-24 0-28.7-23.3-52-52-52H138.6c4-17-.6-35.5-13.8-48.8-20.3-20.3-53.2-20.3-73.5 0L32 342.5V128c0-35.3 28.7-64 64-64zm64 64H96v64c35.3 0 64-28.7 64-64zm384 192c-35.3 0-64 28.7-64 64h64v-64zm-224 32c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96z" />
//         </svg>
//       ),
//     };
//   }

//   if (userCapabilityTopMenu.filter((item) => item.MstMenuHeadingId === 4)) {
//     var dynamnicTopMenu4 = userCapabilityTopMenu
//       .filter((item) => item.MstMenuHeadingId === 4)
//       .map((item) => ({
//         title: item.MenuHeading,
//         menuHeadingId: item.MstMenuHeadingId,
//         menuPath: item.MenuPath,
//         mstMenuId: item.MstMenuId,
//       }));
//   } else {
//     console.log("Reports permission denied");
//   }

//   if (dynamnicTopMenu4.length > 0) {
//     var TopMenuReports = {
//       title: dynamnicTopMenu4[0].title,
//       menuHeadingId: dynamnicTopMenu4[0].menuHeadingId,
//       menuPath: dynamnicTopMenu4[0].menuPath,
//       menuId: dynamnicTopMenu4[0].mstMenuId,
//     };
//     var TopMenuReportsMobile = {
//       title: dynamnicTopMenu4[0].title,
//       menuHeadingId: dynamnicTopMenu4[0].menuHeadingId,
//       menuPath: dynamnicTopMenu4[0].menuPath,
//       menuId: dynamnicTopMenu4[0].mstMenuId,
//       icon: (
//         <svg
//           fill="none"
//           stroke="currentColor"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//           strokeWidth={2}
//           viewBox="0 0 24 24"
//           className="w-6 h-6"
//         >
//           <path stroke="none" d="M0 0h24v24H0z" />
//           <path d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h5.697M18 14v4h4M18 11V7a2 2 0 00-2-2h-2" />
//           <path d="M10 3 H12 A2 2 0 0 1 14 5 V5 A2 2 0 0 1 12 7 H10 A2 2 0 0 1 8 5 V5 A2 2 0 0 1 10 3 z" />
//           <path d="M22 18 A4 4 0 0 1 18 22 A4 4 0 0 1 14 18 A4 4 0 0 1 22 18 z" />
//           <path d="M8 11h4M8 15h3" />
//         </svg>
//       ),
//     };
//   }
//   const createDynamicMenus = (menuHeadingId) => {
//     return userCapabilityTopMenu
//       .filter((item) => item.MstMenuHeadingId === menuHeadingId)
//       .map((item) => ({
//         title: item.MenuHeading,
//         menuHeadingId: item.MstMenuHeadingId,
//         menuPath: item.MenuPath,
//         menuId: item.MstMenuId,
//         relatedMenu: item.RelatedMenu || null,
//       }));
//   };

//   const dynamicMenus = {
//     topMenu: createDynamicMenus(1),
//     adminMenu: createDynamicMenus(2),
//     transactionMenu: createDynamicMenus(3),
//     reportsMenu: createDynamicMenus(4),
//   };

//   const topMenuList = [
//     ...dynamicMenus.topMenu,
//     dynamicMenus.adminMenu[0],
//     dynamicMenus.transactionMenu[0],
//     dynamicMenus.reportsMenu[0],
//   ].filter(Boolean);

//   const topMenuMobileList = [
//     ...dynamnicTopMenuMobile,
//     TopMenuAdminMobile,
//     TopMenuTransactionMobile,
//     TopMenuReportsMobile,
//   ];

//   const filteredTopMenuList = topMenuList.filter(
//     (menuItem) => menuItem !== undefined
//   );

//   const filteredTopMenuListMobile = topMenuMobileList.filter(
//     (menuItem) => menuItem !== undefined
//   );

//   const navBarMenu = {
//     menuWidth: `w-full lg:block px-4 py-2 sm:px-1 lg:px-8`,
//     menuSpace: "flex items-center justify-between gap-3 h-fit",
//     menuList: `ml-10 items-baseline hidden md:flex lg:flex md:ml-2`,
//     logoPosition: "flex items-center w-48",
//     menu: "text-white hover:bg-red-400 px-3 py-2 flex flex-col justify-center rounded-md text-xs font-medium",
//     menuActive: "bg-red-400",
//     hiddenMenuSpace: "px-2 pt-2 pb-3 space-y-1 sm:px-3",
//     menuButton:
//       "bg-gray-800 inline-flex items-center sm:mx-3 md:hidden justify-center lg:p-2 md:p-1 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white",
//     menuButtonHidden:
//       "hover:bg-gray-700 text-white block px-3 py-2 rounded-md text-base font-medium",
//     profileImage: "w-12 h-12 rounded-full bg-white",
//     profileImageText:
//       "w-12 h-12  rounded-full bg-white flex justify-center py-1 align-center text-3xl font-medium text-red-600",
//     profileImagePosition:
//       "flex justify-end justify-evenly gap-2 items-center md:order-2",
//     profileImageButton: "flex justify-center text-sm rounded-full",
//   };
//   const [pageName, setPageName] = useState("");
//   const [viewsAll, setViewsAll] = useState(false);
//   const [notifications, setNotifications] = useState(false);
//   const [notificationDesign, setNotificationDesign] = useState(false);
//   const [userProfilePopUp, setUserProfilePopUp] = useState(false);
//   const [passwordPopUp, setPasswordPopUp] = useState(false);
//   const [systemSettingPopup, setSystemSettingPopup] = useState(false);
//   const navigate = useNavigate();
//   const handlePopup = () => {
//     setUserProfilePopUp(true);
//   };
//   const handlePassword = () => {
//     setPasswordPopUp(true);
//   };
//   const handleNotification = () => {
//     setNotifications(true);
//     setNotificationDesign(true);
//   };
//   const LogOut = async () => {
//     navigate("/");
//     sessionStorage.clear();
//     localStorage.clear();
//   };
//   const handleClose = () => {
//     setUserProfilePopUp(false);
//     setPasswordPopUp(false);
//     setSystemSettingPopup(false);
//     setNotifications(false);
//   };

//   const getUserFirstcharAt = (name) =>
//     name ? name.charAt(0).toUpperCase() : "";

//   const renderProfileImage = () => {
//     if (userProfileImg) {
//       return (
//         <img
//           className={navBarMenu.profileImage}
//           src={userProfileImg}
//           alt="user"
//         />
//       );
//     } else if (userName) {
//       return (
//         <div className={navBarMenu.profileImageText}>
//           {getUserFirstcharAt(userName)}
//         </div>
//       );
//     }
//   };
//   const [bindReferralFollowUpData, setBindReferralFollowUpData] = useState([]);
//   const [bindContraceptiveRenewalData, setBindContraceptiveRenewalData] =
//     useState([]);
//   useState([]);
//   useEffect(() => {
//     if (userProfileDatas?.length) {
//       notificationData(userProfileDatas[0]);
//     }
//   }, [userProfileDatas]);

//   const notificationData = async (user) => {

//     if (!user) return;

//     const data = {
//       mstOrganizationStructureId: user.MstOrganizationId,
//       mstBranchId: user.MstLocationId,
//       mstSdpId: user.MstSDPId || 0,
//       mstUserId: user.MstUserId,
//       mstRoleId: user.MstRoleId,
//     };

//     try {
//       // ✅ Call both APIs in parallel
//       const [referralRes, contraceptiveRes] = await Promise.all([
//         BindPostAPI([data], "NotificationAPI/BindReferralFollowUpNotification"),
//         BindPostAPI([data], "NotificationAPI/BindContraceptiveNotification"),
//       ]);

//       console.log("Referral Response:", referralRes.data);
//       console.log("Contraceptive Response:", contraceptiveRes.data);

//       // ✅ Set states safely
//       setBindContraceptiveRenewalData(
//         contraceptiveRes.data?.Table ?? contraceptiveRes.data?.Table1 ?? []
//       );
//       setBindReferralFollowUpData(
//         referralRes.data?.Table ?? referralRes.data?.Table1 ?? []
//       );
//     } catch (error) {
//       console.error("Error fetching notification data:", error);
//     }
//   };
//   const hasNotifications =
//     (bindReferralFollowUpData?.length || 0) > 0 ||
//     (bindContraceptiveRenewalData?.length || 0) > 0;


//   return (
//     <nav className="bg-[#2d2d6e] p-2">
//       {/* */}
//       <div className={navBarMenu.menuSpace}>
//         <div className="flex items-center">
//           <div className="flex-shrink-0  px-1">
//             <NavLink to="/">
//               <img src={fpaiLogo} className="w-26 h-12" alt="customer Logo" />
//             </NavLink>
//           </div>
//           <div className={navBarMenu.menuList}>
//             {topMenuList.map((menu, index) => (
//               <NavLink
//                 key={`${menu.menuId || "desktop"}-${index}`}
//                 to={menu.menuPath}
//                 className={`${navBarMenu.menu} ${menu.menuHeadingId == currentMenuId
//                   ? navBarMenu.menuActive
//                   : ""
//                   }`}
//                 state={{
//                   isAdd: menu.relatedMenu,
//                   menuId: menu.menuId,
//                   isTransaction: menu.menuHeadingId === 3,
//                 }}
//                 onClick={() => {
//                   setPageName(menu.menuPath);
//                 }}
//               >
//                 {menu.title}
//               </NavLink>
//             ))}
//           </div>
//         </div>
//         <div className=" flex justify-end"></div>
//         <div className=" flex justify-end items-center">

//           {/* <svg
//             viewBox="0 0 24 24"
//             fill="currentColor"
//             onClick={handleNotification}
//             className={
//               "text-white px-3 py-2 flex flex-col justify-center rounded-md w-12 h-12 font-medium"
//             }
//           >
//             <path d="M10 21h4c0 1.1-.9 2-2 2s-2-.9-2-2m11-2v1H3v-1l2-2v-6c0-3.1 2-5.8 5-6.7V4c0-1.1.9-2 2-2s2 .9 2 2v.3c3 .9 5 3.6 5 6.7v6l2 2m-4-8c0-2.8-2.2-5-5-5s-5 2.2-5 5v7h10v-7z" />
//           </svg> */}
//           <div className="relative">
//             <svg
//               viewBox="0 0 24 24"
//               fill="currentColor"
//               onClick={handleNotification}
//               className="text-white px-3 py-2 flex flex-col justify-center rounded-md w-12 h-12 font-medium cursor-pointer"
//             >
//               <path d="M10 21h4c0 1.1-.9 2-2 2s-2-.9-2-2m11-2v1H3v-1l2-2v-6c0-3.1 2-5.8 5-6.7V4c0-1.1.9-2 2-2s2 .9 2 2v.3c3 .9 5 3.6 5 6.7v6l2 2m-4-8c0-2.8-2.2-5-5-5s-5 2.2-5 5v7h10v-7z" />
//             </svg>

//             {hasNotifications && (
//               <span className="absolute top-1 right-1 bg-red-600 text-white text-[10px] font-bold rounded-full h-4 w-4 flex items-center justify-center">
//                 {bindReferralFollowUpData.length + bindContraceptiveRenewalData.length}
//               </span>
//             )}
//           </div>



//           <div
//             className={navBarMenu.profileImagePosition}
//             onClick={() => setViewsAll(!viewsAll)}
//           >
//             <button
//               type="button"
//               className={navBarMenu.profileImageButton}
//               id="user-menu-button"
//               aria-expanded="false"
//               data-dropdown-toggle="user-dropdown"
//               data-dropdown-placement="bottom"
//             >
//               <p
//                 className={
//                   "text-white px-3 py-2 flex flex-col justify-center rounded-md text-xs font-medium"
//                 }
//               >
//                 {userName ? userName : null}
//                 <span className="text-xs text-center">{desigantion}</span>
//               </p>
//               {renderProfileImage()}
//             </button>
//             {viewsAll && (
//               <div
//                 id="dropdownDots"
//                 className="z-10 bg-white absolute top-14 right-5 divide-y divide-gray-100 rounded-lg shadow w-44 "
//               >
//                 <ul
//                   className="py-2 text-sm text-gray-700 "
//                   aria-labelledby="dropdownMenuIconButton"
//                 >
//                   <li>
//                     <a
//                       className="block px-4 py-2 cursor-pointer hover:bg-gray-100 "
//                       onClick={handlePopup}
//                     >
//                       User Profile
//                     </a>
//                   </li>
//                   <li>
//                     <a
//                       className="block px-4 py-2 cursor-pointer hover:bg-gray-100 "
//                       onClick={handlePassword}
//                     >
//                       Change Password
//                     </a>
//                   </li>
//                   <li>
//                     <a
//                       class="block px-4 py-2 cursor-pointer hover:bg-gray-100 "
//                       href="https://fpai-outreach.org/mobileapp/fpai-outreach-mobile.zip"
//                       // href ="http://fpai-outreach-test.xlicon.com/mobileapp/fpai-outreach-mobile.zip"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       download="FPAI-Outreach Mobile APK File"
//                     >
//                       Download Mobile App
//                     </a>
//                   </li>
//                   <li>
//                     <a
//                       className="block px-4 py-2 cursor-pointer hover:bg-gray-100 "
//                       // onClick={(e) => {
//                       //   e.preventDefault();
//                       //   const link = document.createElement('a');
//                       //   link.href = "http://fpai-outreach-dev.xlicon.com/documents/Help%20Document%20for%20FPAI%20Outreach%20Web%20Application%20v1.pdf";
//                       //   link.download = "Help Document for FPAI Outreach Web Application v1.pdf";
//                       //   document.body.appendChild(link);
//                       //   link.click();
//                       //   document.body.removeChild(link);
//                       // }}
//                       //href="http://fpai-outreach-dev.xlicon.com/documents/Help%20Document%20for%20FPAI%20Outreach%20Web%20Application.pdf"
//                       //  href="http://fpai-outreach-test.xlicon.com/documents/Help%20Document%20for%20FPAI%20Outreach%20Web%20Application.pdf"
//                       // href="http://fpai-outreach-test.xlicon.com/documents/Help%20Document%20for%20FPAI%20Outreach%20Web%20Application.pdf"
//                       href="https://fpai-outreach.org/documents/Help%20Document%20for%20FPAI%20Outreach%20Web%20Application.pdf"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       download="Help Document for FPAI Outreach Web Application"
//                     >
//                       Help Document for Web App
//                     </a>
//                   </li>
//                   <li>
//                     <a
//                       className="block px-4 py-2 cursor-pointer hover:bg-gray-100 "
//                       //href="http://fpai-outreach-dev.xlicon.com/documents/Help%20Document%20for%20FPAI%20Outreach%20Mobile%20Application.pdf"
//                       // href="http://fpai-outreach-test.xlicon.com/documents/Help%20Document%20for%20FPAI%20Outreach%20Mobile%20Application.pdf"
//                       href="https://fpai-outreach.org/documents/Help%20Document%20for%20FPAI%20Outreach%20Mobile%20Application.pdf"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       download="Help Document for FPAI Outreach Mobile Application"
//                     >
//                       Help Document for Mobile App
//                     </a>
//                   </li>
//                   <li>
//                     <a
//                       onClick={LogOut}
//                       className="block px-4 py-2 cursor-pointer hover:bg-gray-100 "
//                     >
//                       Log Out
//                     </a>
//                   </li>
//                 </ul>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       <div className="md:hidden  lg:hidden  block" id="mobile-menu">
//         <div
//           className={
//             "px-2 pt-2 pb-3 flex gap-10 justify-center space-y-1 sm:px-3"
//           }
//         >
//           {filteredTopMenuListMobile.map((menu, index) => (
//             <NavLink
//               key={`${menu.menuId || "menu"}-${index}`} // ✅ guaranteed unique
//               to={menu.menuPath}
//               state={{
//                 isAdd: menu.relatedMenu ? menu.relatedMenu : undefined,
//                 menuId: menu.menuId ? menu.menuId : undefined,
//                 isTransaction: true,
//               }}
//               className={navBarMenu.menuButtonHidden}
//               onClick={() => {
//                 setPageName(menu.menuPath);
//               }}
//             >
//               {menu.icon}
//             </NavLink>
//           ))}
//         </div>
//       </div>

//       <MainPopup
//         popUpOpen={notifications}
//         setpopUpOpen={setNotifications}
//         notificationPopups={notificationDesign}
//       >
//         <div>
//           <button className="w-full">
//             <span
//               // className="text-white flex justify-end"
//               onClick={handleClose}
//               className="text-2xl p-0 m-o block float-right mr-3"
//             >
//               &times;
//             </span>
//           </button>
//           <Notifications call={notifications} closePopup={handleClose} />
//         </div>
//       </MainPopup>

//       <MainPopup
//         popUpOpen={userProfilePopUp}
//         setpopUpOpen={setUserProfilePopUp}
//       >
//         <div>
//           <button className="w-full">
//             <span
//               // className="text-white flex justify-end"
//               onClick={handleClose}
//               className="text-2xl p-0 m-o block float-right mr-3"
//             >
//               &times;
//             </span>
//           </button>
//           <UserProfile
//             data={userProfileDatas}
//             closePopup={() => setUserProfilePopUp(!userProfilePopUp)}
//           />
//         </div>
//       </MainPopup>
//       <MainPopup popUpOpen={passwordPopUp} setpopUpOpen={setPasswordPopUp}>
//         <div>
//           <button className="w-full">
//             <span
//               // className="text-white flex justify-end"
//               onClick={handleClose}
//               className="text-2xl p-0 m-o block float-right mr-3"
//             >
//               &times;
//             </span>
//           </button>
//           <PasswordPopup closePopup={handleClose} />
//         </div>
//       </MainPopup>
//       <MainPopup
//         popUpOpen={systemSettingPopup}
//         setpopUpOpen={setSystemSettingPopup}
//       >
//         <div>
//           <button className="w-full">
//             <span
//               // className="text-white flex justify-end"
//               onClick={handleClose}
//               className="text-2xl p-0 m-o block float-right mr-3"
//             >
//               &times;
//             </span>
//           </button>
//           <SystemSettingsPopup closePopup={handleClose} />
//         </div>
//       </MainPopup>
//     </nav>
//   );
// }
// export default TopMenu;

// Code review - In Progress
// Documentation - In Progress
import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import fpaiLogo from "../image/FPAILogo.jpg";
import MainPopup from "../popup-containers/MainPopup";
import UserProfile from "../popup-containers/UserProfile";
import { useUserCapability } from "./ConstantReducerProvider";
import PasswordPopup from "../popup-containers/PasswordPopup";
import SystemSettingsPopup from "../popup-containers/SystemSettingsPopup";
import Notifications from "../popup-containers/Notifications";
import { BindPostAPI } from "../services/APIConnection";

// The MstMenuId that should act as the landing page for the Transactions
// heading (MstMenuHeadingId === 3). 43 = Brochures (/viewbrochure).
const TRANSACTION_LANDING_MENU_ID = 43;

function TopMenu() {
  const loction = useLocation();
  const [currentMenuId, setCurrentMenuId] = useState(null);
  const { userProfileState, dispatch } = useUserCapability();

  const userProfileDatas = userProfileState.userProfile;
  const userCapabilityTopMenu = userProfileState.userVsCapability;
  const userProfileImg =
    userProfileDatas && userProfileDatas.length > 0
      ? userProfileDatas[0].UserProfileImg
      : null;

  const userName =
    userProfileDatas && userProfileDatas.length > 0
      ? userProfileDatas[0].UserName
      : null;
  const desigantion =
    userProfileDatas && userProfileDatas.length > 0
      ? userProfileDatas[0].Designation
      : null;

  useEffect(() => {
    var createdBy = sessionStorage.getItem("createdBy");
    if (createdBy == null || createdBy == "") {
      navigate("/");
    }
  }, []);
  useEffect(() => {
    if (loction) {
      const menuId1 = loction.state?.menuId;
      const MenuId = userCapabilityTopMenu
        .filter((x) => x.MenuPath == loction.pathname)
        .map((item) => item.MstMenuId)
        .toString();
      const getMstMainMenuHeadingId = userCapabilityTopMenu
        .filter((x) => x.MenuPath == loction.pathname)
        .map((item) => item.MstMenuHeadingId)
        .toString();

      if (
        getMstMainMenuHeadingId == 1 ||
        getMstMainMenuHeadingId == 2 ||
        getMstMainMenuHeadingId == 3 ||
        getMstMainMenuHeadingId == 4
      ) {
        setCurrentMenuId(getMstMainMenuHeadingId); // Set current menu ID based on the retrieved ID
      }
      if (menuId1 == "3") {
        setCurrentMenuId(2);
      } else if (MenuId == "3,27") {
        setCurrentMenuId(3);
      }
    }
  }, [loction, userProfileState]);
  if (userCapabilityTopMenu.filter((item) => item.MstMenuHeadingId === 1)) {
    var dynamnicTopMenu = userCapabilityTopMenu
      .filter((item) => item.MstMenuHeadingId === 1)
      .map((item) => ({
        title: item.MenuHeading,
        menuHeadingId: item.MstMenuHeadingId,
        menuPath: item.MenuPath,
      }));

    var dynamnicTopMenuMobile = userCapabilityTopMenu
      .filter((item) => item.MstMenuHeadingId === 1)
      .map((item) => ({
        title: item.MenuHeading,
        menuHeadingId: item.MstMenuHeadingId,
        menuPath: item.MenuPath,
        icon: (
          <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
            <path d="M21 16V4H3v12h18m0-14a2 2 0 012 2v12a2 2 0 01-2 2h-7v2h2v2H8v-2h2v-2H3a2 2 0 01-2-2V4c0-1.11.89-2 2-2h18M5 6h9v5H5V6m10 0h4v2h-4V6m4 3v5h-4V9h4M5 12h4v2H5v-2m5 0h4v2h-4v-2z" />
          </svg>
        ),
      }));
  } else {
    console.log("LandingPage permission denied");
  }

  if (userCapabilityTopMenu.filter((item) => item.MstMenuHeadingId === 2)) {
    var dynamnicTopMenu2 = userCapabilityTopMenu
      .filter((item) => item.MstMenuHeadingId === 2)
      .map((item) => ({
        title: item.MenuHeading,
        menuHeadingId: item.MstMenuHeadingId,
        menuPath: item.MenuPath,
        mstMenuId: item.MstMenuId,
      }));
  } else {
    console.log("Administrator permission denied");
  }

  if (dynamnicTopMenu2.length > 0) {
    var TopMenuAdmin = {
      title: dynamnicTopMenu2[0].title,
      menuHeadingId: dynamnicTopMenu2[0].menuHeadingId,
      menuPath: dynamnicTopMenu2[0].menuPath,
      menuId: dynamnicTopMenu2[0].mstMenuId,
    };

    var TopMenuAdminMobile = {
      title: dynamnicTopMenu2[0].title,
      menuHeadingId: dynamnicTopMenu2[0].menuHeadingId,
      menuPath: dynamnicTopMenu2[0].menuPath,
      menuId: dynamnicTopMenu2[0].mstMenuId,
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
          <path fill="none" d="M0 0h24v24H0z" />
          <path d="M12 14v8H4a8 8 0 018-8zm0-1c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6zm2.595 5.812a3.51 3.51 0 010-1.623l-.992-.573 1-1.732.992.573A3.496 3.496 0 0117 14.645V13.5h2v1.145c.532.158 1.012.44 1.405.812l.992-.573 1 1.732-.992.573a3.51 3.51 0 010 1.622l.992.573-1 1.732-.992-.573a3.496 3.496 0 01-1.405.812V22.5h-2v-1.145a3.496 3.496 0 01-1.405-.812l-.992.573-1-1.732.992-.572zM18 17a1 1 0 100 2 1 1 0 000-2z" />
        </svg>
      ),
    };
  }

  if (userCapabilityTopMenu.filter((item) => item.MstMenuHeadingId === 3)) {
    var dynamnicTopMenu3 = userCapabilityTopMenu
      .filter((item) => item.MstMenuHeadingId === 3)
      .map((item) => ({
        title: item.MenuHeading,
        menuHeadingId: item.MstMenuHeadingId,
        menuPath: item.MenuPath,
        mstMenuId: item.MstMenuId,
        relatedMenu: item.RelatedMenu ? item.RelatedMenu : null,
      }));
  } else {
    console.log("Transaction permission denied");
  }

  if (dynamnicTopMenu3.length > 0) {
    // Prefer Brochures (MstMenuId 43) as the Transactions landing link.
    // Fall back to the first item if the user doesn't have access to it.
    const transactionLandingSource =
      dynamnicTopMenu3.find(
        (item) => item.mstMenuId == TRANSACTION_LANDING_MENU_ID
      ) || dynamnicTopMenu3[0];

    var TopMenuTransaction = {
      title: transactionLandingSource.title,
      menuHeadingId: transactionLandingSource.menuHeadingId,
      menuPath: transactionLandingSource.menuPath,
      menuId: transactionLandingSource.mstMenuId,
      relatedMenu: transactionLandingSource.relatedMenu
        ? transactionLandingSource.relatedMenu
        : null,
    };
    var TopMenuTransactionMobile = {
      title: transactionLandingSource.title,
      menuHeadingId: transactionLandingSource.menuHeadingId,
      menuPath: transactionLandingSource.menuPath,
      menuId: transactionLandingSource.mstMenuId,
      relatedMenu: transactionLandingSource.relatedMenu
        ? transactionLandingSource.relatedMenu
        : null,
      icon: (
        <svg viewBox="0 0 640 512" fill="currentColor" className="w-6 h-6">
          <path d="M535 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l64 64c4.5 4.5 7 10.6 7 17s-2.5 12.5-7 17l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-174-.2c-13.3 0-24-10.7-24-24s10.7-24 24-24h174.1L535 41zM105 377l-23 23h174c13.3 0 24 10.7 24 24s-10.7 24-24 24H81.9l23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 441c-4.5-4.5-7-10.6-7-17s2.5-12.5 7-17l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM96 64h241.9c-3.7 7.2-5.9 15.3-5.9 24 0 28.7 23.3 52 52 52h117.4c-4 17 .6 35.5 13.8 48.8 20.3 20.3 53.2 20.3 73.5 0l19.3-19.3V384c0 35.3-28.7 64-64 64H302.1c3.7-7.2 5.9-15.3 5.9-24 0-28.7-23.3-52-52-52H138.6c4-17-.6-35.5-13.8-48.8-20.3-20.3-53.2-20.3-73.5 0L32 342.5V128c0-35.3 28.7-64 64-64zm64 64H96v64c35.3 0 64-28.7 64-64zm384 192c-35.3 0-64 28.7-64 64h64v-64zm-224 32c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96z" />
        </svg>
      ),
    };
  }

  if (userCapabilityTopMenu.filter((item) => item.MstMenuHeadingId === 4)) {
    var dynamnicTopMenu4 = userCapabilityTopMenu
      .filter((item) => item.MstMenuHeadingId === 4)
      .map((item) => ({
        title: item.MenuHeading,
        menuHeadingId: item.MstMenuHeadingId,
        menuPath: item.MenuPath,
        mstMenuId: item.MstMenuId,
      }));
  } else {
    console.log("Reports permission denied");
  }

  if (dynamnicTopMenu4.length > 0) {
    var TopMenuReports = {
      title: dynamnicTopMenu4[0].title,
      menuHeadingId: dynamnicTopMenu4[0].menuHeadingId,
      menuPath: dynamnicTopMenu4[0].menuPath,
      menuId: dynamnicTopMenu4[0].mstMenuId,
    };
    var TopMenuReportsMobile = {
      title: dynamnicTopMenu4[0].title,
      menuHeadingId: dynamnicTopMenu4[0].menuHeadingId,
      menuPath: dynamnicTopMenu4[0].menuPath,
      menuId: dynamnicTopMenu4[0].mstMenuId,
      icon: (
        <svg
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          viewBox="0 0 24 24"
          className="w-6 h-6"
        >
          <path stroke="none" d="M0 0h24v24H0z" />
          <path d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h5.697M18 14v4h4M18 11V7a2 2 0 00-2-2h-2" />
          <path d="M10 3 H12 A2 2 0 0 1 14 5 V5 A2 2 0 0 1 12 7 H10 A2 2 0 0 1 8 5 V5 A2 2 0 0 1 10 3 z" />
          <path d="M22 18 A4 4 0 0 1 18 22 A4 4 0 0 1 14 18 A4 4 0 0 1 22 18 z" />
          <path d="M8 11h4M8 15h3" />
        </svg>
      ),
    };
  }
  const createDynamicMenus = (menuHeadingId) => {
    return userCapabilityTopMenu
      .filter((item) => item.MstMenuHeadingId === menuHeadingId)
      .map((item) => ({
        title: item.MenuHeading,
        menuHeadingId: item.MstMenuHeadingId,
        menuPath: item.MenuPath,
        menuId: item.MstMenuId,
        relatedMenu: item.RelatedMenu || null,
      }));
  };

  // Picks a specific menu item (by MstMenuId) to act as the "landing" link
  // for a heading section. Falls back to the first available item if the
  // preferred one isn't present (e.g. the user doesn't have access to it).
  const pickLandingMenu = (menuArray, preferredMenuId) => {
    if (!menuArray || menuArray.length === 0) return undefined;
    const preferred = menuArray.find((item) => item.menuId == preferredMenuId);
    return preferred || menuArray[0];
  };

  const dynamicMenus = {
    topMenu: createDynamicMenus(1),
    adminMenu: createDynamicMenus(2),
    transactionMenu: createDynamicMenus(3),
    reportsMenu: createDynamicMenus(4),
  };

  // Transactions landing link = Brochures (MstMenuId 43), with fallback
  // to the first item in the Transactions menu if unavailable.
  const transactionLandingMenu = pickLandingMenu(
    dynamicMenus.transactionMenu,
    TRANSACTION_LANDING_MENU_ID
  );

  const topMenuList = [
    ...dynamicMenus.topMenu,
    dynamicMenus.adminMenu[0],
    transactionLandingMenu,
    dynamicMenus.reportsMenu[0],
  ].filter(Boolean);

  const topMenuMobileList = [
    ...dynamnicTopMenuMobile,
    TopMenuAdminMobile,
    TopMenuTransactionMobile,
    TopMenuReportsMobile,
  ];

  const filteredTopMenuList = topMenuList.filter(
    (menuItem) => menuItem !== undefined
  );

  const filteredTopMenuListMobile = topMenuMobileList.filter(
    (menuItem) => menuItem !== undefined
  );

  const navBarMenu = {
    menuWidth: `w-full lg:block px-4 py-2 sm:px-1 lg:px-8`,
    menuSpace: "flex items-center justify-between gap-3 h-fit",
    menuList: `ml-10 items-baseline hidden md:flex lg:flex md:ml-2`,
    logoPosition: "flex items-center w-48",
    menu: "text-white hover:bg-red-400 px-3 py-2 flex flex-col justify-center rounded-md text-xs font-medium",
    menuActive: "bg-red-400",
    hiddenMenuSpace: "px-2 pt-2 pb-3 space-y-1 sm:px-3",
    menuButton:
      "bg-gray-800 inline-flex items-center sm:mx-3 md:hidden justify-center lg:p-2 md:p-1 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white",
    menuButtonHidden:
      "hover:bg-gray-700 text-white block px-3 py-2 rounded-md text-base font-medium",
    profileImage: "w-12 h-12 rounded-full bg-white",
    profileImageText:
      "w-12 h-12  rounded-full bg-white flex justify-center py-1 align-center text-3xl font-medium text-red-600",
    profileImagePosition:
      "flex justify-end justify-evenly gap-2 items-center md:order-2",
    profileImageButton: "flex justify-center text-sm rounded-full",
  };
  const [pageName, setPageName] = useState("");
  const [viewsAll, setViewsAll] = useState(false);
  const [notifications, setNotifications] = useState(false);
  const [notificationDesign, setNotificationDesign] = useState(false);
  const [userProfilePopUp, setUserProfilePopUp] = useState(false);
  const [passwordPopUp, setPasswordPopUp] = useState(false);
  const [systemSettingPopup, setSystemSettingPopup] = useState(false);
  const navigate = useNavigate();
  const handlePopup = () => {
    setUserProfilePopUp(true);
  };
  const handlePassword = () => {
    setPasswordPopUp(true);
  };
  const handleNotification = () => {
    setNotifications(true);
    setNotificationDesign(true);
  };
  const LogOut = async () => {
    navigate("/");
    sessionStorage.clear();
    localStorage.clear();
  };
  const handleClose = () => {
    setUserProfilePopUp(false);
    setPasswordPopUp(false);
    setSystemSettingPopup(false);
    setNotifications(false);
  };

  const getUserFirstcharAt = (name) =>
    name ? name.charAt(0).toUpperCase() : "";

  const renderProfileImage = () => {
    if (userProfileImg) {
      return (
        <img
          className={navBarMenu.profileImage}
          src={userProfileImg}
          alt="user"
        />
      );
    } else if (userName) {
      return (
        <div className={navBarMenu.profileImageText}>
          {getUserFirstcharAt(userName)}
        </div>
      );
    }
  };
  const [bindReferralFollowUpData, setBindReferralFollowUpData] = useState([]);
  const [bindContraceptiveRenewalData, setBindContraceptiveRenewalData] =
    useState([]);
  useState([]);
  useEffect(() => {
    if (userProfileDatas?.length) {
      notificationData(userProfileDatas[0]);
    }
  }, [userProfileDatas]);

  const notificationData = async (user) => {

    if (!user) return;

    const data = {
      mstOrganizationStructureId: user.MstOrganizationId,
      mstBranchId: user.MstLocationId,
      mstSdpId: user.MstSDPId || 0,
      mstUserId: user.MstUserId,
      mstRoleId: user.MstRoleId,
    };

    try {
      // ✅ Call both APIs in parallel
      const [referralRes, contraceptiveRes] = await Promise.all([
        BindPostAPI([data], "NotificationAPI/BindReferralFollowUpNotification"),
        BindPostAPI([data], "NotificationAPI/BindContraceptiveNotification"),
      ]);

      console.log("Referral Response:", referralRes.data);
      console.log("Contraceptive Response:", contraceptiveRes.data);

      // ✅ Set states safely
      setBindContraceptiveRenewalData(
        contraceptiveRes.data?.Table ?? contraceptiveRes.data?.Table1 ?? []
      );
      setBindReferralFollowUpData(
        referralRes.data?.Table ?? referralRes.data?.Table1 ?? []
      );
    } catch (error) {
      console.error("Error fetching notification data:", error);
    }
  };
  const hasNotifications =
    (bindReferralFollowUpData?.length || 0) > 0 ||
    (bindContraceptiveRenewalData?.length || 0) > 0;


  return (
    <nav className="bg-[#2d2d6e] p-2">
      {/* */}
      <div className={navBarMenu.menuSpace}>
        <div className="flex items-center">
          <div className="flex-shrink-0  px-1">
            <NavLink to="/">
              <img src={fpaiLogo} className="w-26 h-12" alt="customer Logo" />
            </NavLink>
          </div>
          <div className={navBarMenu.menuList}>
            {topMenuList.map((menu, index) => (
              <NavLink
                key={`${menu.menuId || "desktop"}-${index}`}
                to={menu.menuPath}
                className={`${navBarMenu.menu} ${menu.menuHeadingId == currentMenuId
                  ? navBarMenu.menuActive
                  : ""
                  }`}
                state={{
                  isAdd: menu.relatedMenu,
                  menuId: menu.menuId,
                  isTransaction: menu.menuHeadingId === 3,
                }}
                onClick={() => {
                  setPageName(menu.menuPath);
                }}
              >
                {menu.title}
              </NavLink>
            ))}
          </div>
        </div>
        <div className=" flex justify-end"></div>
        <div className=" flex justify-end items-center">

          {/* <svg
            viewBox="0 0 24 24"
            fill="currentColor"
            onClick={handleNotification}
            className={
              "text-white px-3 py-2 flex flex-col justify-center rounded-md w-12 h-12 font-medium"
            }
          >
            <path d="M10 21h4c0 1.1-.9 2-2 2s-2-.9-2-2m11-2v1H3v-1l2-2v-6c0-3.1 2-5.8 5-6.7V4c0-1.1.9-2 2-2s2 .9 2 2v.3c3 .9 5 3.6 5 6.7v6l2 2m-4-8c0-2.8-2.2-5-5-5s-5 2.2-5 5v7h10v-7z" />
          </svg> */}
          <div className="relative">
            <svg
              viewBox="0 0 24 24"
              fill="currentColor"
              onClick={handleNotification}
              className="text-white px-3 py-2 flex flex-col justify-center rounded-md w-12 h-12 font-medium cursor-pointer"
            >
              <path d="M10 21h4c0 1.1-.9 2-2 2s-2-.9-2-2m11-2v1H3v-1l2-2v-6c0-3.1 2-5.8 5-6.7V4c0-1.1.9-2 2-2s2 .9 2 2v.3c3 .9 5 3.6 5 6.7v6l2 2m-4-8c0-2.8-2.2-5-5-5s-5 2.2-5 5v7h10v-7z" />
            </svg>

            {hasNotifications && (
              <span className="absolute top-1 right-1 bg-red-600 text-white text-[10px] font-bold rounded-full h-4 w-4 flex items-center justify-center">
                {bindReferralFollowUpData.length + bindContraceptiveRenewalData.length}
              </span>
            )}
          </div>



          <div
            className={navBarMenu.profileImagePosition}
            onClick={() => setViewsAll(!viewsAll)}
          >
            <button
              type="button"
              className={navBarMenu.profileImageButton}
              id="user-menu-button"
              aria-expanded="false"
              data-dropdown-toggle="user-dropdown"
              data-dropdown-placement="bottom"
            >
              <p
                className={
                  "text-white px-3 py-2 flex flex-col justify-center rounded-md text-xs font-medium"
                }
              >
                {userName ? userName : null}
                <span className="text-xs text-center">{desigantion}</span>
              </p>
              {renderProfileImage()}
            </button>
            {viewsAll && (
              <div
                id="dropdownDots"
                className="z-10 bg-white absolute top-14 right-5 divide-y divide-gray-100 rounded-lg shadow w-44 "
              >
                <ul
                  className="py-2 text-sm text-gray-700 "
                  aria-labelledby="dropdownMenuIconButton"
                >
                  <li>
                    <a
                      className="block px-4 py-2 cursor-pointer hover:bg-gray-100 "
                      onClick={handlePopup}
                    >
                      User Profile
                    </a>
                  </li>
                  <li>
                    <a
                      className="block px-4 py-2 cursor-pointer hover:bg-gray-100 "
                      onClick={handlePassword}
                    >
                      Change Password
                    </a>
                  </li>
                  <li>
                    <a
                      class="block px-4 py-2 cursor-pointer hover:bg-gray-100 "
                      href="https://fpai-outreach.org/mobileapp/fpai-outreach-mobile.zip"
                      // href ="http://fpai-outreach-test.xlicon.com/mobileapp/fpai-outreach-mobile.zip"
                      target="_blank"
                      rel="noopener noreferrer"
                      download="FPAI-Outreach Mobile APK File"
                    >
                      Download Mobile App
                    </a>
                  </li>
                  <li>
                    <a
                      className="block px-4 py-2 cursor-pointer hover:bg-gray-100 "
                      // onClick={(e) => {
                      //   e.preventDefault();
                      //   const link = document.createElement('a');
                      //   link.href = "http://fpai-outreach-dev.xlicon.com/documents/Help%20Document%20for%20FPAI%20Outreach%20Web%20Application%20v1.pdf";
                      //   link.download = "Help Document for FPAI Outreach Web Application v1.pdf";
                      //   document.body.appendChild(link);
                      //   link.click();
                      //   document.body.removeChild(link);
                      // }}
                      //href="http://fpai-outreach-dev.xlicon.com/documents/Help%20Document%20for%20FPAI%20Outreach%20Web%20Application.pdf"
                      //  href="http://fpai-outreach-test.xlicon.com/documents/Help%20Document%20for%20FPAI%20Outreach%20Web%20Application.pdf"
                      // href="http://fpai-outreach-test.xlicon.com/documents/Help%20Document%20for%20FPAI%20Outreach%20Web%20Application.pdf"
                      href="https://fpai-outreach.org/documents/Help%20Document%20for%20FPAI%20Outreach%20Web%20Application.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      download="Help Document for FPAI Outreach Web Application"
                    >
                      Help Document for Web App
                    </a>
                  </li>
                  <li>
                    <a
                      className="block px-4 py-2 cursor-pointer hover:bg-gray-100 "
                      //href="http://fpai-outreach-dev.xlicon.com/documents/Help%20Document%20for%20FPAI%20Outreach%20Mobile%20Application.pdf"
                      // href="http://fpai-outreach-test.xlicon.com/documents/Help%20Document%20for%20FPAI%20Outreach%20Mobile%20Application.pdf"
                      href="https://fpai-outreach.org/documents/Help%20Document%20for%20FPAI%20Outreach%20Mobile%20Application.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      download="Help Document for FPAI Outreach Mobile Application"
                    >
                      Help Document for Mobile App
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={LogOut}
                      className="block px-4 py-2 cursor-pointer hover:bg-gray-100 "
                    >
                      Log Out
                    </a>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="md:hidden  lg:hidden  block" id="mobile-menu">
        <div
          className={
            "px-2 pt-2 pb-3 flex gap-10 justify-center space-y-1 sm:px-3"
          }
        >
          {filteredTopMenuListMobile.map((menu, index) => (
            <NavLink
              key={`${menu.menuId || "menu"}-${index}`} // ✅ guaranteed unique
              to={menu.menuPath}
              state={{
                isAdd: menu.relatedMenu ? menu.relatedMenu : undefined,
                menuId: menu.menuId ? menu.menuId : undefined,
                isTransaction: true,
              }}
              className={navBarMenu.menuButtonHidden}
              onClick={() => {
                setPageName(menu.menuPath);
              }}
            >
              {menu.icon}
            </NavLink>
          ))}
        </div>
      </div>

      <MainPopup
        popUpOpen={notifications}
        setpopUpOpen={setNotifications}
        notificationPopups={notificationDesign}
      >
        <div>
          <button className="w-full">
            <span
              // className="text-white flex justify-end"
              onClick={handleClose}
              className="text-2xl p-0 m-o block float-right mr-3"
            >
              &times;
            </span>
          </button>
          <Notifications call={notifications} closePopup={handleClose} />
        </div>
      </MainPopup>

      <MainPopup
        popUpOpen={userProfilePopUp}
        setpopUpOpen={setUserProfilePopUp}
      >
        <div>
          <button className="w-full">
            <span
              // className="text-white flex justify-end"
              onClick={handleClose}
              className="text-2xl p-0 m-o block float-right mr-3"
            >
              &times;
            </span>
          </button>
          <UserProfile
            data={userProfileDatas}
            closePopup={() => setUserProfilePopUp(!userProfilePopUp)}
          />
        </div>
      </MainPopup>
      <MainPopup popUpOpen={passwordPopUp} setpopUpOpen={setPasswordPopUp}>
        <div>
          <button className="w-full">
            <span
              // className="text-white flex justify-end"
              onClick={handleClose}
              className="text-2xl p-0 m-o block float-right mr-3"
            >
              &times;
            </span>
          </button>
          <PasswordPopup closePopup={handleClose} />
        </div>
      </MainPopup>
      <MainPopup
        popUpOpen={systemSettingPopup}
        setpopUpOpen={setSystemSettingPopup}
      >
        <div>
          <button className="w-full">
            <span
              // className="text-white flex justify-end"
              onClick={handleClose}
              className="text-2xl p-0 m-o block float-right mr-3"
            >
              &times;
            </span>
          </button>
          <SystemSettingsPopup closePopup={handleClose} />
        </div>
      </MainPopup>
    </nav>
  );
}
export default TopMenu;